import * as actionTypes from "../actionTypes";
import * as binderTabsActions from "./binderTabsActions";
import * as tilesActions from "./tilesActions";
import uuid from "uuid";

export function addTileSections(tileSections) {
	let mappedSections = tileSections;
	if (tileSections && tileSections.length) {
		mappedSections = tileSections.map(section => ({
			desktop: section.desktop,
			id: section.tiles ? uuid.v4() : null,
			name: section.name,
			phone: section.phone,
			tablet: section.tablet,
			tileIds: section.tiles ? section.tiles.map(t => t.__id) : undefined,
		}));
	}

	return {
		type: actionTypes.TILE_SECTION_ADD_MULTIPLE,
		tileSections: mappedSections,
	};
}

export function removeTileSection(sectionId) {
	return {
		type: actionTypes.TILE_SECTION_REMOVE,
		sectionId,
	};
}

export function removeTileSections(tileSectionIds) {
	return {
		type: actionTypes.TILE_SECTION_REMOVE_MULTIPLE,
		tileSectionIds,
	};
}

export function loadSection(apiSection, binderTabId) {
	return dispatch => {
		let tiles = apiSection.tiles;
		if (apiSection && apiSection.tiles && apiSection.tiles.length) {
			const action = dispatch(tilesActions.addTiles(apiSection.tiles));
			tiles = action.tiles;
		}

		const { tileSections } = dispatch(addTileSections([{ ...apiSection, tiles }]));
		if (tileSections.length) {
			const { id, name } = tileSections[0];
			dispatch(binderTabsActions.setBinderTabsTileSection(binderTabId, id, name));
			return id;
		}

		return null;
	};
}
